import React from "react";
import DashboardLayout from "../DashboardLayout";
import { Badge, Form } from "react-bootstrap";
import "../../Styles/Profile.css";
import { useEffect, useState } from "react";
import { FaRegEdit } from "react-icons/fa";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { RiCameraFill } from "react-icons/ri";
import { handleErrors, maskContactNumber } from "../../services/dataManager";
import { useNavigate, useParams } from "react-router-dom";
import {
  addNewOrganization,
  fetchCharitableOrgById,
  updateCharitableOrg,
  uploadOrganizationImage,
  uploadOrganizationThumbnail,
} from "../../services/axios/apiManager";
import { format } from "date-fns";
import { customStyles } from "../games/customStyles";
import { foucusedAreasData } from "../../services/staticData";
import { useFormik } from "formik";
import { CharOrgsValidationSchema } from "../charitableOrganizations/validationSchema";
import { baseURL } from "../../services/axios/eps";
import { toast } from "sonner";
import LoadingSpinner from "../../Components/spinner";
import OrgDetails from "./orgDetails";

function CharitableProfile() {
  const navigate = useNavigate();
  const { id } = useParams();
  const animatedComponents = makeAnimated();
  const [isEditing, setIsEditing] = useState(id ? false : true);
  const [orgsData, setOrgsData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [thmbUrl, setThmbUrl] = useState(null);

  // // // make selected thumbnail URL
  const makeThumbnailURL = (event) => {
    if (event?.currentTarget?.files?.length) {
      formik?.setFieldValue("thumbnail", event.currentTarget.files[0]);
      const previewUrl = URL.createObjectURL(event.currentTarget.files[0]);
      setThmbUrl(previewUrl);
    } else {
      formik?.setFieldValue("thumbnail", orgsData.thumbnail);
      setThmbUrl(null);
    }
  };

  // // // make selected img URL
  const makeImageURL = (event) => {
    if (event?.currentTarget?.files?.length) {
      formik?.setFieldValue("image", event.currentTarget.files[0]);
      const previewUrl = URL.createObjectURL(event.currentTarget.files[0]);
      setImageUrl(previewUrl);
    } else {
      formik?.setFieldValue("image", orgsData.image);
      setImageUrl(null);
    }
  };
  // // // Add/Update Org Image logic
  const uploadImage = async (orgId, image) => {
    const formData = new FormData();
    formData.append("image", image);
    const res = await uploadOrganizationImage(orgId, formData);
    if (res?.data.success) {
      toast.success("Image has been uploaded", { duration: 2000 });
    } else {
      handleErrors(res, navigate);
    }
  };
  // // // Add/Update Org Thumbnail logic
  const uploadThumbnail = async (orgId, image) => {
    const formData = new FormData();
    formData.append("image", image);
    const res = await uploadOrganizationThumbnail(orgId, formData);
    if (res?.data.success) {
      toast.success("Thumbnail has been uploaded", { duration: 2000 });
    } else {
      handleErrors(res, navigate);
    }
  };
  // // // Update Organization Logic
  const updateOrg = async (values) => {
    const { image, thumbnail, ...data } = values;
    if (data?.status === "active") {
      data.status = 1;
    } else {
      data.status = 0;
    }
    const res = await updateCharitableOrg({
      id,
      ...data,
    });
    if (res?.data?.success) {
      if (image !== orgsData.image) {
        uploadImage(id, image);
      }
      if (thumbnail !== orgsData.thumbnail) {
        uploadThumbnail(id, thumbnail);
      }

      toast.success("Charitable organization has been updated.", {
        duration: 2000,
      });
      await getData();
      setIsEditing(false);
    } else {
      handleErrors(res, navigate, "Update Organization:");
    }
  };

  // // // Add New Organization Logic
  const addOrg = async (values) => {
    const { image, thumbnail, ...data } = values;

    if (data?.status === "active") {
      data.status = 1;
    } else {
      data.status = 0;
    }

    const res = await addNewOrganization(data);
    if (res?.data?.success && res?.data?.data) {
      const orgId = res?.data?.data.id;
      if (orgId) {
        if (image) {
          await uploadImage(orgId, image);
        }
        if (thumbnail) {
          await uploadThumbnail(orgId, thumbnail);
        }
      } else {
        toast.error("Image and thumbnail has not been uploaded", {
          duration: 2000,
        });
      }
      toast.success("Charitable organization has been added", {
        duration: 2000,
      });
      navigate("/CharitableOrganization");
    } else {
      handleErrors(res, navigate);
    }
  };
  // // // Handle Submit button for add update Organization
  const handleSubmitButton = async () => {
    if (id && isEditing) {
      formik.handleSubmit();
    } else if (id && !isEditing) {
      setIsEditing(true);
    } else {
      formik.handleSubmit();
    }
  };
  // // // Fromik for form and its validations validations
  const formik = useFormik({
    initialValues: {
      name: orgsData?.name || "",
      email: orgsData?.email || "",
      founded: orgsData?.founded || "",
      address: orgsData?.address || "",
      phone: orgsData?.phone || "",
      website: orgsData?.website || "",
      focusAreas: orgsData?.focusAreas || [],
      mission: orgsData?.mission || "",
      image: orgsData?.image || "",
      thumbnail: orgsData?.thumbnail || "",
      status: orgsData?.status || 1,
      image: orgsData?.image || "",
      thumbnail: orgsData?.thumbnail || "",
    },
    enableReinitialize: true,
    validationSchema: CharOrgsValidationSchema,
    onSubmit: async (values) => {
      try {
        if (loading) {
          return;
        }
        setLoading(true);
        if (id) {
          await updateOrg(values);
        } else {
          await addOrg(values);
        }
      } catch (error) {
        toast.success("Something went wrong try again later.", {
          duration: 2000,
        });
      } finally {
        setLoading(false);
      }
    },
  });
  // // // fetch organization on start
  const getData = async () => {
    if (id) {
      const res = await fetchCharitableOrgById(id);
      if (res?.data?.success && res?.data?.data) {
        setOrgsData(res.data.data);
      } else {
        handleErrors(res, navigate, "Organization:");
      }
    }
  };
  useEffect(() => {
    getData();
    return () => {
      setImageUrl(null);
      setThmbUrl(null);
      setOrgsData(null);
    };
  }, []);

  const handleImageClick = () => {
    document.getElementById("imageUploadInput").click();
  };
  const handleThumbClick = () => {
    document.getElementById("thumbUploadInput").click();
  };
  return (
    <DashboardLayout>
      <div>
        <div>
          <div>
            <div>
              <div className="card overflow-hidden">
                <div className="bg-blend-darken" style={{ minHeight: 200 }}>
                  <img
                    crossorigin="anonymous"
                    src={
                      imageUrl ||
                      (orgsData?.image
                        ? orgsData.image.includes("https")
                          ? orgsData.image
                          : `${baseURL}/uploads/file/${orgsData.image}`
                        : "https://img.freepik.com/premium-vector/abstract-technology-background-with-molecular-structure-genetic-engineering-molecules-dna_120542-1393.jpg?semt=ais_hybrid")
                    }
                    alt=""
                    className="card-img-top profile-wid-img object-fit-cover"
                    style={{ maxHeight: 320 }}
                  />
                  <div className="position-absolute end-0 top-0 m-3">
                    <input
                      id="imageUploadInput"
                      type="file"
                      accept="image/*"
                      className="profile-img-file-input d-none"
                      onChange={makeImageURL}
                    />
                    {isEditing && (
                      <label
                        className="profile-photo-edit avatar-xs"
                        style={{ cursor: "pointer" }}
                        onClick={handleImageClick}
                      >
                        <span
                          className="avatar-title rounded-circle bg-light text-body border shadow-sm d-flex align-items-center justify-content-center"
                          style={{
                            width: "35px",
                            height: "35px",
                            border: "2px solid #aaa",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
                            transition: "0.3s",
                          }}
                        >
                          <RiCameraFill size={18} />
                        </span>
                      </label>
                    )}
                  </div>
                </div>
                <div className="card-body pt-0 mt-[-2rem]">
                  <div className="text-center">
                    <div className="profile-user position-relative d-inline-block mx-auto">
                      <div
                        className="avatar-lg rounded-circle overflow-hidden d-flex align-items-center justify-content-center"
                        style={{
                          width: "150px",
                          height: "150px",
                          border: "5px solid #ccc",
                          backgroundColor: "#f0f0f0",
                          position: "relative",
                        }}
                      >
                        <img
                          crossorigin="anonymous"
                          src={
                            thmbUrl
                              ? thmbUrl
                              : orgsData?.thumbnail
                                ? `${baseURL}/uploads/file/${orgsData.thumbnail}`
                                : "/chartyProfile.jpg"
                          }
                          alt="Profile"
                          className="img-thumbnail user-profile-image"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "50%",
                          }}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/chartyProfile.jpg";
                          }}
                        />
                      </div>

                      {/* Edit Thumbnail */}
                      <div className="avatar-xs p-0 rounded-circle profile-photo-edit position-absolute end-0 bottom-0">
                        <input
                          id="thumbUploadInput"
                          type="file"
                          accept="image/*"
                          className="profile-img-file-input d-none"
                          onChange={makeThumbnailURL}
                        />
                        {isEditing && (
                          <label
                            className="profile-photo-edit avatar-xs"
                            style={{ cursor: "pointer" }}
                            onClick={handleThumbClick}
                          >
                            <span
                              className="avatar-title rounded-circle bg-light text-body border shadow-sm d-flex align-items-center justify-content-center"
                              style={{
                                width: "35px",
                                height: "35px",
                                border: "2px solid #aaa",
                                boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
                                transition: "0.3s",
                              }}
                            >
                              <RiCameraFill size={18} />
                            </span>
                          </label>
                        )}
                      </div>
                    </div>

                    <div className="mt-3">
                      <h5 className="mb-0">
                        {orgsData?.name || ""}
                        <i className="bi bi-patch-check-fill align-baseline text-info ms-1" />
                      </h5>
                    </div>
                  </div>
                </div>

                <div class="container-fluid">
                  <div class="d-flex justify-content-end">
                    {id && !isEditing && (
                      <button
                        className="btn btn-success d-flex align-items-center gap-2"
                        onClick={() => {
                          handleSubmitButton();
                        }}
                      >
                        <FaRegEdit className="me-1" />
                        Edit Organization
                      </button>
                    )}
                  </div>
                </div>
              </div>

              <div>
                <div className="tab-content mt-4">
                  {/*  */}
                  {isEditing ? (
                    <div>
                      <div className="tab-content">
                        <div
                          className="tab-pane active"
                          id="personalDetails"
                          role="tabpanel"
                        >
                          <Form
                            onSubmit={formik.handleSubmit}
                            className="card-header bg-dark text-white card shadow-lg border-0 rounded-2"
                          >
                            <div className="row">
                              <div className="col-lg-6">
                                <Form.Group
                                  className="mb-3"
                                  data-testid="Add-New-Organization"
                                >
                                  <label className="form-label">
                                    Organizations Name
                                  </label>
                                  <Form.Control
                                    type="text"
                                    data-testid="orgName"
                                    className="bg-dark text-light border-light input-placeholder-light form-control"
                                    {...formik.getFieldProps("name")}
                                    isInvalid={
                                      formik.touched.name &&
                                      !!formik.errors.name
                                    }
                                  />
                                  <Form.Control.Feedback type="invalid" data-testid="name-validation">
                                    {formik.errors.name}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>
                              <div className="col-lg-6">
                                <Form.Group className="mb-3">
                                  <label className="form-label">Email</label>
                                  <Form.Control
                                    type="email"
                                    data-testid="Email"
                                    className="bg-dark text-light border-light input-placeholder-light form-control"
                                    {...formik.getFieldProps("email")}
                                    isInvalid={
                                      formik.touched.email &&
                                      !!formik.errors.email
                                    }
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {formik.errors.email}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>
                              <div className="col-lg-6">
                                <Form.Group
                                  className="mb-3"
                                  data-testid="Phone-Number"
                                >
                                  <label className="form-label">
                                    Phone Number
                                  </label>
                                  <Form.Control
                                  data-testid="PhoneNumber"
                                    type="text"
                                    className="bg-dark text-light border-light input-placeholder-light form-control"
                                    {...formik.getFieldProps("phone")}
                                    onChange={(event) => {
                                      formik.setFieldValue(
                                        "phone",
                                        maskContactNumber(event)
                                      );
                                    }}
                                    isInvalid={
                                      formik.touched.phone &&
                                      !!formik.errors.phone
                                    }
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {formik.errors.phone}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>

                              <div className="col-lg-6">
                                <Form.Group className="mb-3">
                                  <label className="form-label">Wesbite</label>
                                  <Form.Control
                                    type="text"
                                    data-testid="Wesbite"
                                    className="bg-dark text-light border-light input-placeholder-light form-control"
                                    {...formik.getFieldProps("website")}
                                    isInvalid={
                                      formik.touched.website &&
                                      !!formik.errors.website
                                    }
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {formik.errors.website}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>

                              <div className="col-lg-6">
                                <Form.Group className="mb-3">
                                  <label className="form-label">Address</label>
                                  <Form.Control
                                    type="text"
                                    data-testid="Address"
                                    className="bg-dark text-light border-light input-placeholder-light form-control"
                                    {...formik.getFieldProps("address")}
                                    isInvalid={
                                      formik.touched.address &&
                                      !!formik.errors.address
                                    }
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {formik.errors.address}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>

                              <div className="col-lg-6">
                                <Form.Group className="mb-3">
                                  <label
                                    htmlFor="firstnameInput"
                                    className="form-label"
                                  >
                                    Founded Year
                                  </label>
                                  <Form.Control
                                    type="number"
                                    data-testid="Founded-Year"
                                    className="bg-dark text-light border-light input-placeholder-light form-control"
                                    {...formik.getFieldProps("founded")}
                                    isInvalid={
                                      formik.touched.founded &&
                                      !!formik.errors.founded
                                    }
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {formik.errors.founded}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>
                              <div className="col-lg-6">
                                <Form.Group className="mb-3">
                                  <label
                                    htmlFor="statusSelect"
                                    className="form-label"
                                  >
                                    Status
                                  </label>
                                  <Form.Select
                                    id="statusSelect"
                                    data-testid="Status"
                                    className="bg-dark text-light border-light input-placeholder-light form-control"
                                    {...formik.getFieldProps("status")}
                                    isInvalid={
                                      formik.touched.status &&
                                      !!formik.errors.status
                                    }
                                  >
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                  </Form.Select>
                                  <Form.Control.Feedback type="invalid">
                                    {formik.errors.status}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>
                              <div className="col-lg-12">
                                <Form.Group className="mb-3">
                                  <label
                                    htmlFor="emailInput"
                                    className="form-label"
                                  >
                                    Focused Areas
                                  </label>
                                  <Select
                                    data-testid="react-select"
                                    closeMenuOnSelect={false}
                                    components={animatedComponents}
                                    isSearchable={false}
                                    isMulti
                                    options={foucusedAreasData}
                                    styles={customStyles}
                                    value={
                                      foucusedAreasData.filter((option) =>
                                        formik.values.focusAreas?.includes(
                                          option.value
                                        )
                                      ) || []
                                    }
                                    onChange={(selectedOptions) => {
                                      formik.setFieldValue(
                                        "focusAreas",
                                        selectedOptions
                                          ? selectedOptions.map(
                                              (option) => option.value
                                            )
                                          : []
                                      );
                                    }}
                                  />
                                  {formik?.errors?.focusAreas &&
                                  formik?.touched?.focusAreas ? (
                                    <span className="text-danger">
                                      {formik?.errors?.focusAreas}
                                    </span>
                                  ) : null}
                                </Form.Group>
                              </div>
                              <div className="col-lg-12">
                                <Form.Group className="mb-3">
                                  <label
                                    htmlFor="firstnameInput"
                                    className="form-label"
                                  >
                                    Mission
                                  </label>
                                  <Form.Control
                                    as="textarea"
                                    data-testid="Mission"
                                    rows={3}
                                    className="bg-dark text-light border-light input-placeholder-light form-control"
                                    {...formik.getFieldProps("mission")}
                                    isInvalid={
                                      formik.touched.mission &&
                                      !!formik.errors.mission
                                    }
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {formik.errors.mission}
                                  </Form.Control.Feedback>
                                </Form.Group>
                              </div>

                              <div class="container-fluid">
                                <div class="d-flex justify-content-end">
                                  {loading && <LoadingSpinner size={"lg"} />}
                                  {id && isEditing && (
                                    <button
                                      className="btn btn-secondary d-flex align-items-center mx-2"
                                      onClick={() => {
                                        setIsEditing(false);
                                      }}
                                    >
                                      Cancel
                                    </button>
                                  )}
                                  <button
                                    className="btn btn-success d-flex align-items-center gap-2"
                                    onClick={() => {
                                      handleSubmitButton();
                                    }}
                                  >
                                    <FaRegEdit className="me-1" />
                                    {id
                                      ? "Update Organization"
                                      : "Add New Organization"}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </Form>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <OrgDetails orgsData={orgsData} />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}

export default CharitableProfile;
